import React, { useState } from 'react';
import './ListConfigModal.css';
import AppIcon from './icons/AppIcon';

export default function ListConfigModal({ list, onClose, onSave, onDelete }) {
  const isNewList = !list;
  
  const [listData, setListData] = useState(list || {
    title: '',
    color: '#b43bea',
    icon: 'list',
    limit: null,
    isBacklog: false,
    isCompleted: false,
    autoArchiveDays: null,
    automations: []
  });

  const handleSave = () => {
    if (!listData.title.trim()) {
      alert('O título da lista é obrigatório');
      return;
    }
    onSave(listData);
    onClose();
  };

  const availableIcons = [
    'list', 'inbox', 'schedule', 'done', 'archive', 'flag',
    'star', 'bookmark', 'label', 'folder', 'work', 'home',
    'shopping_cart', 'bug_report', 'lightbulb', 'rocket_launch'
  ];

  const availableColors = [
    { name: 'Roxo', value: '#b43bea' },
    { name: 'Ciano', value: '#44e1ff' },
    { name: 'Verde', value: '#10b981' },
    { name: 'Azul', value: '#3b82f6' },
    { name: 'Rosa', value: '#ec4899' },
    { name: 'Laranja', value: '#f59e0b' },
    { name: 'Vermelho', value: '#ef4444' },
    { name: 'Índigo', value: '#6366f1' },
    { name: 'Amarelo', value: '#eab308' },
    { name: 'Cinza', value: '#6b7280' }
  ];

  return (
    <div className="modal-overlay-list" onClick={onClose}>
      <div className="list-config-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="list-modal-header">
          <div className="list-modal-title-section">
            <AppIcon name="view_week" className="list-modal-icon" />
            <h2>{isNewList ? 'Criar Nova Lista' : 'Configurar Lista'}</h2>
          </div>
          <button className="btn-close-modal" onClick={onClose}>
            <AppIcon name="close" />
          </button>
        </div>

        <div className="list-modal-content">
          {/* Coluna Principal */}
          <div className="list-modal-main">
            {/* Informações Básicas */}
            <div className="list-section">
              <h4>
                <AppIcon name="info" />
                Informações Básicas
              </h4>
              
              <div className="form-group">
                <label>Título da Lista *</label>
                <input
                  type="text"
                  value={listData.title}
                  onChange={(e) => setListData({ ...listData, title: e.target.value })}
                  placeholder="Ex: A Fazer, Em Progresso, Concluído..."
                  className="list-input"
                  autoFocus
                />
              </div>
            </div>

            {/* Aparência */}
            <div className="list-section">
              <h4>
                <AppIcon name="palette" />
                Aparência
              </h4>

              <div className="form-group">
                <label>Ícone</label>
                <div className="icon-grid">
                  {availableIcons.map(icon => (
                    <button
                      key={icon}
                      className={`icon-option ${listData.icon === icon ? 'active' : ''}`}
                      onClick={() => setListData({ ...listData, icon })}
                      style={{ 
                        color: listData.icon === icon ? listData.color : '#9bb3c7',
                        borderColor: listData.icon === icon ? listData.color : 'transparent'
                      }}
                    >
                      <AppIcon name={icon} />
                    </button>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label>Cor</label>
                <div className="color-grid">
                  {availableColors.map(color => (
                    <button
                      key={color.value}
                      className={`color-option ${listData.color === color.value ? 'active' : ''}`}
                      onClick={() => setListData({ ...listData, color: color.value })}
                      style={{ backgroundColor: color.value }}
                      title={color.name}
                    >
                      {listData.color === color.value && (
                        <AppIcon name="check" />
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* Preview */}
              <div className="list-preview">
                <div className="preview-label">Preview:</div>
                <div className="preview-list-header" style={{ borderColor: listData.color }}>
                  <AppIcon name={listData.icon} style={{ color: listData.color }} />
                  <span>{listData.title || 'Título da Lista'}</span>
                </div>
              </div>
            </div>

            {/* Configurações Avançadas */}
            <div className="list-section">
              <h4>
                <AppIcon name="settings" />
                Configurações Avançadas
              </h4>

              <div className="form-group">
                <label>Limite de Cards (WIP)</label>
                <input
                  type="number"
                  value={listData.limit || ''}
                  onChange={(e) => setListData({ ...listData, limit: e.target.value ? parseInt(e.target.value) : null })}
                  placeholder="Sem limite"
                  className="list-input"
                  min="1"
                />
                <small>Número máximo de cards permitidos nesta lista</small>
              </div>

              <div className="form-group">
                <label>Auto-arquivar após (dias)</label>
                <input
                  type="number"
                  value={listData.autoArchiveDays || ''}
                  onChange={(e) => setListData({ ...listData, autoArchiveDays: e.target.value ? parseInt(e.target.value) : null })}
                  placeholder="Desativado"
                  className="list-input"
                  min="1"
                />
                <small>Cards serão arquivados automaticamente após X dias nesta lista</small>
              </div>

              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={listData.isBacklog}
                    onChange={(e) => setListData({ ...listData, isBacklog: e.target.checked })}
                  />
                  <span>Marcar como Backlog</span>
                </label>
                <small>Lista de itens pendentes/futuros</small>
              </div>

              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={listData.isCompleted}
                    onChange={(e) => setListData({ ...listData, isCompleted: e.target.checked })}
                  />
                  <span>Marcar como Lista de Conclusão</span>
                </label>
                <small>Cards movidos para esta lista são marcados como concluídos</small>
              </div>
            </div>

            {/* Automações */}
            <div className="list-section">
              <h4>
                <AppIcon name="bolt" />
                Automações
              </h4>

              <div className="automation-placeholder">
                <AppIcon name="auto_awesome" />
                <p>Configure regras automáticas para esta lista</p>
                <button 
                  className="btn-add-automation"
                  onClick={() => alert('Funcionalidade de automações será implementada')}
                >
                  <AppIcon name="add" />
                  Adicionar Automação
                </button>
              </div>

              <div className="automation-examples">
                <strong>Exemplos de automações:</strong>
                <ul>
                  <li>Quando card movido para esta lista → adicionar tag</li>
                  <li>Quando card movido para esta lista → atribuir a usuário</li>
                  <li>Quando card movido para esta lista → definir prazo</li>
                  <li>Quando card movido para esta lista → enviar notificação</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="list-modal-sidebar">
            <h4>Ações</h4>

            <button className="sidebar-btn-list" onClick={handleSave}>
              <AppIcon name="save" />
              {isNewList ? 'Criar Lista' : 'Salvar Alterações'}
            </button>

            <button 
              className="sidebar-btn-list"
              onClick={() => {
                setListData({
                  ...listData,
                  title: '',
                  color: '#b43bea',
                  icon: 'list',
                  limit: null,
                  isBacklog: false,
                  isCompleted: false,
                  autoArchiveDays: null
                });
              }}
            >
              <AppIcon name="refresh" />
              Limpar Campos
            </button>

            {!isNewList && (
              <>
                <h4 style={{ marginTop: '1.5rem' }}>Informações</h4>
                
                <div className="info-box">
                  <div className="info-item">
                    <AppIcon name="credit_card" />
                    <div>
                      <strong>Cards</strong>
                      <p>{list?.cards?.length || 0} itens</p>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <AppIcon name="schedule" />
                    <div>
                      <strong>Criada em</strong>
                      <p>{list?.createdAt ? new Date(list.createdAt).toLocaleDateString('pt-BR') : 'N/A'}</p>
                    </div>
                  </div>
                </div>

                {/* ✅ Botão de deletar apenas para listas não-padrão */}
                {!list?.is_default && (
                  <>
                    <h4 style={{ marginTop: '1.5rem' }}>Perigo</h4>
                    <button 
                      className="sidebar-btn-delete"
                      onClick={() => {
                        if (window.confirm('Tem certeza que deseja deletar esta lista? Esta ação não pode ser desfeita.')) {
                          onDelete(list.id);
                          onClose();
                        }
                      }}
                      style={{
                        background: '#ef4444',
                        color: 'white',
                        width: '100%',
                        padding: '0.75rem',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: '500',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.background = '#dc2626'}
                      onMouseLeave={(e) => e.target.style.background = '#ef4444'}
                    >
                      <AppIcon name="delete" />
                      Deletar Lista
                    </button>
                  </>
                )}
              </>
            )}

            <h4 style={{ marginTop: '1.5rem' }}>Dicas</h4>
            
            <div className="tips-box">
              <p>💡 Use cores diferentes para categorizar listas</p>
              <p>⚡ Configure automações para agilizar o fluxo</p>
              <p>📊 Defina limites WIP para controlar o trabalho</p>
              <p>✅ Marque listas de conclusão para rastreamento</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="list-modal-footer">
          <button className="btn-cancel-list" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn-save-list" onClick={handleSave}>
            <AppIcon name="check" />
            {isNewList ? 'Criar Lista' : 'Salvar Alterações'}
          </button>
        </div>
      </div>
    </div>
  );
}
